import React from 'react';

import { Button as CastlecraftButton } from 'castlecraft-ui';

const Button = ({ buttonText, handleClick, type, ...rest }) => {
  return (
    <CastlecraftButton
      onClick={() => handleClick()}
      variant={type === 'secondary' ? 'secondary' : 'primary'}
      {...rest}
    >
      {buttonText}
    </CastlecraftButton>
  );
};

export default Button;
